// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__fxjIB","list":"BalanceDue_list__2PZmt","listRow":"BalanceDue_listRow__158YY","total":"BalanceDue_total__d7Lbp"};